module.exports = __webpack_public_path__ + "img/18.8.C.cf0e243d.png";